import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Icon = ({ icon, className, onIconClick, size }) => {

    const onClick = () => {
        onIconClick()
    }

    return(
        <FontAwesomeIcon icon={icon} className={className} size={size} onClick={() => onClick()}/>
    )
}

Icon.propTypes = {
    icon: PropTypes.array,
    className: PropTypes.string,
    onIconClick: PropTypes.func,
    size: PropTypes.string,
}

Icon.defaultProps = {
    icon: [],
    className: '',
    onIconClick: ()=>{},
    size: null
}

export default Icon